document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.section-box').forEach(initSlider);

  function initSlider(root) {
    const slider = root.querySelector('.slider');
    const dotsEl = root.querySelector('.dots');
    const prev   = root.querySelector('.indicator .prev');
    const next   = root.querySelector('.indicator .next');

    // スライダーのないセクションは何もしない
    if (!slider || !dotsEl || !prev || !next) return;

    const cards = [...slider.querySelectorAll('.slider-card')];
    let current = 0;

    const dots = cards.map((_, i) => {
      const b = document.createElement('button');
      b.className = 'dot';
      b.setAttribute('aria-label', `${i + 1} / ${cards.length}`);
      b.addEventListener('click', () => goTo(i));
      dotsEl.appendChild(b);
      return b;
    });

    function goTo(i) {
      i = Math.min(Math.max(i, 0), cards.length - 1);
      slider.scrollTo({ left: cards[i].offsetLeft, behavior: 'smooth' });
    }

    function render(i) {
      current = i;
      dots.forEach((d, n) => {
        d.classList.toggle('active', n === i);
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      prev.disabled = i === 0;
      next.disabled = i === cards.length - 1;
    }

    function nearestIndex() {
      const max = slider.scrollWidth - slider.clientWidth;
      if (slider.scrollLeft >= max - 2) return cards.length - 1;
      let idx = 0, min = Infinity;
      cards.forEach((c, i) => {
        const d = Math.abs(c.offsetLeft - slider.scrollLeft);
        if (d < min) { min = d; idx = i; }
      });
      return idx;
    }

    let ticking = false;
    slider.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const i = nearestIndex();
        if (i !== current) render(i);
        ticking = false;
      });
    }, { passive: true });

    prev.addEventListener('click', () => goTo(current - 1));
    next.addEventListener('click', () => goTo(current + 1));

    render(0);
  }
});